import axios from '@axios'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchAllDepartments(ctx, queryParams) {
      return new Promise((resolve, reject) => {
        axios
          .get('cms/admin/librarycategories')
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },

     
    createDepartment(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .post('cms/admin/librarycategory',  userData  )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    updatelibrarycategory(ctx, userData) {
      return new Promise((resolve, reject) => {
        axios
          .put('cms/admin/updatelibrarycategory',  userData  )
          .then(response => resolve(response))
          .catch(error => reject(error))
      })
    },
    


  },
}
